import axios from 'axios';
import { API_URL } from '../config/api';

// Detect device type from user agent
const detectDeviceType = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  if (/tablet|ipad|playbook|silk/i.test(userAgent)) {
    return 'tablet';
  }
  
  if (/mobile|iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(userAgent)) {
    return 'mobile';
  }
  
  return 'desktop';
};

// Track a view
export const trackView = async (pagePath = null) => {
  try {
    const deviceType = detectDeviceType();
    const userAgent = navigator.userAgent;
    
    await axios.post(`${API_URL}/api/analytics/track`, {
      device_type: deviceType,
      page_path: pagePath || window.location.pathname,
      user_agent: userAgent,
      ip_address: null // Server will handle this
    });
  } catch (error) {
    // Silently fail - don't interrupt user experience
    console.error('Failed to track view:', error);
  }
};

